module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "keyword-settings"
  }, [_vm._c('div', {
    staticClass: "dropdown open"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "keywordSettingsDropdownMenuButton",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Edit keyword settings\n    ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    style: ([_vm.dropdownVisible ? {
      'display': 'block'
    } : {
      'display': 'none'
    }]),
    attrs: {
      "aria-labelledby": "keywordSettingsDropdownMenuButton",
      "id": "divShowKeywordSettings"
    }
  }, [_vm._c('strong', [_vm._v("Select a keyword difficulty")]), _vm._v(" "), _vm._c('span', {
    staticClass: "text-right close-btn",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "options"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.keywordDifficulty),
      expression: "keywordDifficulty",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "radKeywordDifficultyEasy",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.saveChapter(1)
      },
      "click": function($event) {
        _vm.keywordDifficulty = _vm._n("1")
      }
    }
  }), _vm._v(" "), _vm._c('label', {
    attrs: {
      "for": "radKeywordDifficultyEasy"
    }
  }, [_vm._v("Easy")]), _vm._c('br'), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.keywordDifficulty),
      expression: "keywordDifficulty",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "radKeywordDifficultyMod",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("2"))
    },
    on: {
      "change": function($event) {
        _vm.saveChapter(2)
      },
      "click": function($event) {
        _vm.keywordDifficulty = _vm._n("2")
      }
    }
  }), _vm._v(" "), _vm._c('label', {
    attrs: {
      "for": "radKeywordDifficultyMod"
    }
  }, [_vm._v("Moderate")]), _vm._c('br'), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.keywordDifficulty),
      expression: "keywordDifficulty",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "radKeywordDifficultyDif",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("3"))
    },
    on: {
      "change": function($event) {
        _vm.saveChapter(3)
      },
      "click": function($event) {
        _vm.keywordDifficulty = _vm._n("3")
      }
    }
  }), _vm._v(" "), _vm._c('label', {
    attrs: {
      "for": "radKeywordDifficultyDif"
    }
  }, [_vm._v("Difficult")])]), _vm._v(" "), _vm._c('hr'), _vm._v("\n      " + _vm._s(_vm.description)), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('strong', [_vm._v("Example:")]), _vm._c('br'), _vm._v("\n      'Cerebral Edema' =  "), _vm._c('span', {
    staticClass: "clex-keyword"
  }, [_vm._v(_vm._s(_vm.example))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ade0cda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-editor/KeywordSettings.vue
// module id = 699
// module chunks = 1